import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-menu-base',
  templateUrl: './menu-base.component.html',
  styleUrls: ['./menu-base.component.scss']
})
export class MenuBaseComponent implements OnInit {
    @Input() menu: IMenuDefinition;
    

    constructor() { }

    ngOnInit(): void {
    }

    handleSubmenuOpened(item: IMenuItem){
        const openItems = this.menu.items.filter(x=>x.submenuShow && x !== item);
        openItems.forEach(i => i.submenuShow = false);
    }

}

export interface IMenuDefinition {
    title: string;
    showFooter: boolean;
    footerItem?: IMenuItem;
    items: IMenuItem[];
    urlBase?: string;
    urlIndex?: number;
}

export interface IMenuItem {
    active: boolean;
    submenuShow: boolean;
    text: string;
    icon: string;
    type: string;   // url, action, submenu
    url: string[];
    urlSegment?: string;
    action?: Function;
    submenuItems: IMenuSubitem[];
    disabled?: boolean;
    id?: string;
    showBadge?: false;
    badgeText?: string;
}

export interface IMenuSubitem {
    text: string;
    type: string;
    url: string[];
    action?: Function;
    showBadge?: false;
    badgeText?: string;
    id?: string;
}

export const menuRoutingHandler = (menu: IMenuDefinition, url: string) => {
    if(!url.startsWith(menu.urlBase) && !url.startsWith('/' + menu.urlBase)){
        return;
    }

    const urlPieces = url.startsWith("/") ? url.substring(1).split("/") : url;

    //We are interested in the pieces from index 2 onwards, if index
    //  index 0 is 'company'
    
    //Reset the current active state
    const activeMenu = menu.items.filter(x=>x.active);
    activeMenu.forEach(i => {
        i.active = false
    });
    if(menu.footerItem){
        menu.footerItem.active = false;
    }
    

    //Protection against nothing
    if(urlPieces.length >= menu.urlIndex){
        //Ok, let's hunt
        const firstMenu = menu.items.find(x=>x.urlSegment === urlPieces[menu.urlIndex]);
        if(firstMenu){
            firstMenu.active = true;

            if(firstMenu.submenuItems?.length > 0 ){
                firstMenu.submenuShow = true;
            }
            //If we wanted to implement a submenu, we'd do it.
            // if(firstMenu.submenuItems?.length > 0 && urlPieces.length > 3){
            //     const secondMenu = firstMenu.submenuItems.find(x=>x.url.indexOf(urlPieces[3]) > -1 );
            //     if(secondMenu){
            //         secondMenu.
            //     }
            // }
        }else{
            if(menu.footerItem?.urlSegment === urlPieces[menu.urlIndex]){
                menu.footerItem.active = true;
            }
        }
    }
}